import axios from "axios";
import { useCallback, useEffect, useState } from "react";

import { API, getAuthHeader } from "../lib/kds";

const INTERVALO_MS = 10000;

/** Situação de cada item da comanda de uma mesa (em produção / pronto /
 *  entregue), pra tela de Mesas pendurar o selo ao lado do item.
 *
 *  O servidor devolve a lista na mesma ordem do carrinho da mesa, com o nome
 *  junto. `situacaoDe(item, itens)` acha a posição do item no array que a tela
 *  está desenhando e só devolve o selo se o nome bater — o carrinho no
 *  navegador pode estar um passo à frente do servidor, e selo no item errado
 *  é pior que selo nenhum. Devolve `{situacao, entregue_at}` — a hora da
 *  entrega fica marcada no selo.
 */
export default function useSituacaoItensMesa(mesaId) {
  const [dados, setDados] = useState([]);

  const ler = useCallback(async () => {
    if (!mesaId) { setDados([]); return; }
    try {
      const { data } = await axios.get(`${API}/kds/mesas/${mesaId}/itens`, getAuthHeader());
      setDados(Array.isArray(data?.itens) ? data.itens : []);
    } catch (_) { /* sem selo: a comanda continua igual */ }
  }, [mesaId]);

  useEffect(() => {
    ler();
    if (!mesaId) return undefined;
    const id = setInterval(ler, INTERVALO_MS);
    return () => clearInterval(id);
  }, [mesaId, ler]);

  const situacaoDe = useCallback((item, itens) => {
    const pos = (itens || []).indexOf(item);
    const d = pos >= 0 ? dados[pos] : null;
    if (!d || !d.situacao) return null;
    const nome = String(item.name || item.nome || "").trim().toLowerCase();
    if (String(d.nome || "").trim().toLowerCase() !== nome) return null;
    return { situacao: d.situacao, entregue_at: d.entregue_at || null };
  }, [dados]);

  return { situacaoDe, recarregar: ler };
}
